import {
  ODataPeriod,
  OInvoiceGoodsType,
} from "../../../../../shared/constants";

export interface CreateInvoiceSummaryDialogProps {
  open: boolean;
  onHide: (open: boolean) => void;
  currencies: Record<string, any>[];
  refreshLazyData: () => void;
}

export const createSummaryDefaultValues = {
  dataPeriod: ODataPeriod.MONTH,
  dataPeriodDate: "",
  monthOrQuarter: new Date().getMonth() + 1,
  totalSubmit: 0,
  year: new Date().getFullYear(),
  status: "",
  isFirstSubmission: true,
  currencyCode: "VND",
  goodsType: OInvoiceGoodsType.OTHERS,
  multiTax: false,
  creationDate: new Date(),
};
